import { Item } from './multi-select';
import { CheckIcon } from '../../atoms/icons';

const MultiCheckBox = ({ selected }: { selected?: boolean }) => {
  return selected ? (
    <div className="bg-br-primary h-4 w-4 flex-shrink-0 rounded-[4px] p-[2px] text-white">
      <CheckIcon className="h-full w-full" />
    </div>
  ) : (
    <div className="h-4 w-4 flex-shrink-0 rounded-[4px] border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800"></div>
  );
};
const SingleRadio = ({ selected }: { selected?: boolean }) => {
  return selected ? (
    <div className="border-br-primary h-4 w-4 flex-shrink-0 rounded-full border-4 p-[2px]"></div>
  ) : (
    <div className="h-4 w-4 flex-shrink-0 rounded-full border-2 border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800"></div>
  );
};

export const DefaultItemStyle = <T extends Item>({
  active,
  selected,
  mode,
  option,
}: {
  selected?: boolean;
  active?: boolean;
  option: T;
  mode?: 'single' | 'multiple';
}) => {
  return (
    <button
      className={`${
        option.disabled ? 'z-0 cursor-not-allowed !opacity-40' : ''
      } ${
        active ? 'bg-br-primary/5 text-br-primary' : 'text-gray-900 dark:text-gray-100'
      } group inline-flex w-full cursor-pointer items-center gap-2 rounded-md px-2 py-2 pr-4 text-sm focus:outline-none`}
    >
      {mode !== 'single' ? (
        <MultiCheckBox selected={selected} />
      ) : (
        <SingleRadio selected={selected} />
      )}
      <div
        className="inline-flex w-full items-center truncate"
        data-testid="multi-select-item-label"
      >
        {option.label || option.value}
      </div>
    </button>
  );
};
